import Button from './styles';

/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';

/**
 * Função default dos botoes da tool bar onde cada um possui 
 * seu titulo, sua descrição e seus efeitos ao passar o mouse 
 * por cada um
 * 
 * @param {*} children filho
 * @param {string} tooltip titulo e subtitulo
 * @param {*} tooltipDisabled
 * @param {boolean} disabled 
 * @param {boolean} onClick Captura o click
 * @param {number} hide tamanho
 * @param {boolean} active Ativa a função de barra
 * @param {boolean} activeWithBgColor Barra azul em cada botao ao passar o cursor
 * @param {string} description Descrição de cara botao da toolbar
 * @param {*} props Resto
 * @returns Titulo ,descrição e efeitos de cada botao da toolbar 
 */
const ButtonWithTooltip = ({
  children,
  tooltip,
  tooltipDisabled,
  disabled,
  onClick,
  hide,
  active,
  activeWithBgColor = false,
  description,
  ...props
}) => {
  return (
    !hide && (
      <Tooltip
        title={tooltip}
        description={description}
        disabled={tooltipDisabled}
        disableHoverListener={tooltipDisabled || false}
      >
        <Button
          className={active ? 'active' : disabled ? 'disabled' : ''}
          activeWithBgColor={activeWithBgColor}
          onClick={(e) => !disabled && onClick && onClick(e)}
          {...props}
        >
          {children}
        </Button>
      </Tooltip>
    )
  );
};

ButtonWithTooltip.properties = {
  ignore: true,
};

export default ButtonWithTooltip;
